export const SEO_META = {
  en: {
    title: "Zory AI | AI Interior Design & Furniture",
    description:
      "Discovery Platform. Create realistic AI interior designs and furnish your space with ease. Zory AI turns text, photos, sketches, and floor plans into room designs with real furniture, prices,",
    image: "/og/link-image-english.jpg?v=5",
    locale: "en_US",
  },
  ar: {
    title: "زوري للذكاء الاصطناعي | منصة ذكية لتصميم الديكور الداخلي واكتشاف الأثاث",
    description:
      "صمّم مساحات داخلية واقعية بالذكاء الاصطناعي، وأثّث مساحتك بسهولة. منصة زوري تُحول النصوص، والصور، والرسومات، ومخططات المساحات إلى تصاميم غرف مرتبطة بأثاث حقيقي، وأسعار، وأبعاد، ومتاجر.",
    image: "/og/link-image-arabic.jpg?v=5",
    locale: "ar_AE",
  },
}

export function getSeoLanguage(pathname = "") {
  const path = String(pathname || "")
  return path === "/en" || path.startsWith("/en/") ? "en" : "ar"
}

function setMetaTag(selector, attr, key, value) {
  let element = document.querySelector(selector)
  if (!element) {
    element = document.createElement("meta")
    element.setAttribute(attr, key)
    document.head.appendChild(element)
  }
  element.setAttribute("content", value)
}

export function applySeoMeta(lang, pathname = window.location.pathname) {
  const meta = SEO_META[lang] || SEO_META.ar
  const origin = window.location.origin
  const imageUrl = `${origin}${meta.image}`
  const pageUrl = `${origin}${pathname}${window.location.search || ""}`

  document.title = meta.title
  document.documentElement.lang = lang
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr"

  setMetaTag('meta[name="description"]', "name", "description", meta.description)
  setMetaTag('meta[property="og:title"]', "property", "og:title", meta.title)
  setMetaTag(
    'meta[property="og:description"]',
    "property",
    "og:description",
    meta.description,
  )
  setMetaTag('meta[property="og:image"]', "property", "og:image", imageUrl)
  setMetaTag(
    'meta[property="og:image:secure_url"]',
    "property",
    "og:image:secure_url",
    imageUrl,
  )
  setMetaTag(
    'meta[property="og:image:type"]',
    "property",
    "og:image:type",
    "image/jpeg",
  )
  setMetaTag('meta[property="og:image:width"]', "property", "og:image:width", "1800")
  setMetaTag('meta[property="og:image:height"]', "property", "og:image:height", "945")
  setMetaTag('meta[property="og:type"]', "property", "og:type", "website")
  setMetaTag('meta[property="og:locale"]', "property", "og:locale", meta.locale)
  setMetaTag('meta[property="og:site_name"]', "property", "og:site_name", "Zory AI")
  setMetaTag('meta[property="og:url"]', "property", "og:url", pageUrl)
  setMetaTag('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image")
  setMetaTag('meta[name="twitter:title"]', "name", "twitter:title", meta.title)
  setMetaTag(
    'meta[name="twitter:description"]',
    "name",
    "twitter:description",
    meta.description,
  )
  setMetaTag('meta[name="twitter:image"]', "name", "twitter:image", imageUrl)
}
